export class StatoFascicoloConfiguration {
  public static BOZZA: string = 'BOZZA';
  public static DA_COMPLETARE: string = 'DA_COMPLETARE';
  public static IN_SMISTAMENTO: string = 'IN_SMISTAMENTO';
  public static IN_ASSEGNAZIONE: string = 'IN_ASSEGNAZIONE';
  public static IN_ASSEGNAZIONE_LEGALE: string = 'IN_ASSEGNAZIONE_LEGALE';
  public static IN_LAVORAZIONE: string = 'IN_LAVORAZIONE';
  public static DEFINITO: string = 'DEFINITO';
  public static ARCHIVIATO: string = 'ARCHIVIATO';
  public static RIUNITO: string = 'RIUNITO';
}

export class StatoPraticaConfiguration {
  public static BOZZA: string = 'BOZZA';
  public static PENDENTE: string = 'PENDENTE';
  public static DEFINITA: string = 'DEFINITA';
  public static ARCHIVIATA: string = 'ARCHIVIATA';
  public static RIUNITA: string = 'RIUNITA';
}
